import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addVitalsApgarFields = (pcr: IPcr): IPcr => {
  try {
    if (pcr?.patient?.patientVitals && pcr?.patient?.patientVitals.length > 0) {
      pcr.patient.patientVitals.forEach((vital) => {
        setValueForPathWithCreate(vital, 'totalApgarScore', null)
        setValueForPathWithCreate(vital, 'totalApgarScorePNNV', null)
        setValueForPathWithCreate(vital, 'apgar', null)
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addVitalsApgarFields: ${error}`)
    throw error
  }
}
